// Estado inicial do formulário do wizard de cadastro de negócio.
// Extraído de pages/Cadastrar.js — mantém o objeto imutável e testável.
//
// A função recebe `{ latitude, longitude }` (opcional) para pré-preencher
// os campos de localização quando o usuário já autorizou geolocalização.

/**
 * @param {{latitude?: number, longitude?: number}} coords — coords iniciais
 * @returns {object} defaultBusinessForm — payload inicial do wizard
 */
export const createDefaultBusinessForm = ({ latitude = 0, longitude = 0 } = {}) => ({
  // Informações Básicas
  cnpj_cpf: '',
  nome: '',
  nome_fantasia: '',
  descricao_curta: '',
  descricao: '',
  categoria: '',
  categorias_secundarias: [],
  tags: [],
  subcategoria: '',
  subcategorias: [],  // multi-select (iter 214) — sincroniza com `subcategoria` (compat).
  ano_fundacao: '',

  // Perfil Econômico
  tem_cnpj: false,
  tipo_empresa: '',
  situacao_renda: '',
  situacao_ocupacao: '',
  colaboradores_diretos: '',
  colaboradores_indiretos: '',
  contratacao_sazonal: false,
  periodos_sazonais: '',

  // Localização
  tipo_localizacao: 'area_urbana',
  distrito: '',
  comunidade: '',
  ponto_referencia: '',
  privacidade_localizacao: 'endereco_completo',
  cep: '',
  rua: '',
  numero: '',
  complemento: '',
  endereco: '',
  bairro: '',
  municipio_id: '',
  territory_id: '',
  is_sede: null,
  distrito_id: '',
  latitude,
  longitude,

  // Como Atende aos Clientes
  loja_fisica: false,
  atendimento_no_meu_local: false,
  atendimento_no_local_cliente: false,
  atendimento_com_agendamento: false,
  atendimento_online: false,
  delivery: false,
  retirada_no_local: false,
  entrega_combinada: false,
  itinerante: false,
  ocultar_endereco: false,
  area_cobertura: '',

  // Contato & Digital
  telefone_fixo: '',
  whatsapp: '',
  email: '',
  site: '',
  loja_online: '',
  instagram: '',

  // Funcionamento
  horarios: [
    { dia: 'segunda', abre: '08:00', fecha: '18:00', fechado: false },
    { dia: 'terca', abre: '08:00', fecha: '18:00', fechado: false },
    { dia: 'quarta', abre: '08:00', fecha: '18:00', fechado: false },
    { dia: 'quinta', abre: '08:00', fecha: '18:00', fechado: false },
    { dia: 'sexta', abre: '08:00', fecha: '18:00', fechado: false },
    { dia: 'sabado', abre: '08:00', fecha: '12:00', fechado: false },
    { dia: 'domingo', abre: '', fecha: '', fechado: true },
  ],
  horarios_especiais: '',
  apenas_agendamento: false,
  emergencial_24h: false,

  // Serviços
  entrega: false,
  atende_domicilio: false,
  promocao: false,
  link_delivery: '',
  faixa_preco: '',

  // Comodidades
  acessibilidade: false,
  banheiro_publico: false,
  estacionamento: '',
  wifi_gratis: false,
  pet_friendly: false,
  espaco_kids: false,
  ar_condicionado: false,
  area_externa: false,
  seguranca: false,

  // Pagamentos
  aceita_dinheiro: true,
  aceita_cartao_credito: false,
  aceita_cartao_debito: false,
  aceita_pix: false,
  aceita_convenios: false,
  convenios_descricao: '',

  // Diferenciais
  producao_artesanal: false,
  produtos_sustentaveis: false,
  certificacoes: [],
  cooperativa: false,
  empresa_familiar: false,

  // Social & Impacto
  projetos_sociais: false,
  emprega_comunidade: false,
  trabalha_inclusao: false,
  apoia_cultura: false,
  iniciativas_sustentaveis: [],

  // Contratação
  esta_contratando: false,
  vagas: [],

  // Mídia
  avatar_url: '',
  images: [],
  imagens: {},

  // Consentimentos
  aceita_politica_privacidade: false,
  aceita_termos_uso: false,
  aceita_comunicacoes: false,

  // Gestão do Cadastro (NOVO)
  manager_role: 'OWNER',
  manager_relation: 'PROPRIETARIO',
  manager_relation_description: '',
  terms_manager_accepted: false,
});
